export default {
  discountConfig: null,
};
